import { render, staticRenderFns } from "./ProcuraCard.vue?vue&type=template&id=ac45fd66&"
import script from "./ProcuraCard.vue?vue&type=script&lang=js&"
export * from "./ProcuraCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports